import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { BsCheck2All } from "react-icons/bs";
import { RiCloseLargeFill } from "react-icons/ri";
import { useNavigate, useParams } from "react-router-dom";
import {
  getProjectInfoById,
  runApproveReject,
} from "../../../../../api/apiCallManager";
import useProjectInfoQuery from "../../../../../components/hooks/useProjectInfoQuery";
import AccessTo from "../../../../../components/is-show/AccessTo";
import { showSuccess } from "../../../../../helpers/alerts";
import { PA } from "../../../../router/AddRoutesJson";
import FLProjectsTab from "./FLProjectsTab";

function FLProjectCreation() {
  const { id } = useParams();
  const [isDisabled, setIsDisable] = useState(false);
  const {
    data: projectInfoData,
    error,
    isLoading,
  } = useProjectInfoQuery(id, getProjectInfoById);
  const navigate = useNavigate();
  const appRejMutation = useMutation({
    mutationFn: runApproveReject,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        showSuccess("Project Approved..");
        navigate("/fl-project");
        setIsDisable(true);
      }
    },
  });

  const handleApprove = (appStatus) => {
    let payload = {
      event_type: "approve/reject",
      projectKey: projectInfoData?.project_key,
      project_id: id,
      status: appStatus,
    };
    appRejMutation.mutate(payload);
  };

  return (
    <div>
      <div className="mx-2   border-[1.5px] border-[#D9D9D9]  rounded-[6px] bg-white p-3 h-[100%]">
        {/* <div className="flex items-center justify-between pb-2">
          <p> Create FL Project</p>
          <p className=" bg-blue-600 p-2 rounded-sm">
            <IoClose color="white" size={14} />
          </p>
        </div> */}
        <div className="py-1"></div>
        <FLProjectsTab />
      </div>
      {/* {JSON.stringify(projectInfoData.projectStatus == "Pending Approval")} */}

      {/* {projectInfoData?.projectStatus && (
        <div className="my-3 flex justify-center">
          <TrainModelButton projectData={projectInfoData} />
        </div>
      )} */}

      {/* {projectInfoData?.projectStatus && (
        <AccessTo role={[PA]}>
          <div className="my-3"></div>
          <div className="flex justify-end mb-4">
            <button
              disabled={
                isDisabled ||
                projectInfoData?.projectStatus !== "Pending Approval"
              }
              className="mx-3  hover:bg-green-500  flex items-center bg-green-400 text-[green] rounded-[3px] text-[13px] px-8 py-2 "
              onClick={() => handleApprove("approved")}
            >
              <BsCheck2All className="me-1" />
              Approve
            </button>
            <button
              disabled={
                isDisabled ||
                projectInfoData?.projectStatus !== "Pending Approval"
              }
              onClick={() => handleApprove("rejected")}
              className="ms-3  hover:bg-red-500 flex items-center bg-red-400 text-red-900 rounded-[3px] text-[13px] px-8 py-2 "
            >
              <RiCloseLargeFill className="me-1" />
              Reject
            </button>
          </div>
        </AccessTo>
      )} */}
      <div className="py-3"></div>
    </div>
  );
}

export default FLProjectCreation;
